var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lottie-widget",style:(_vm.style)},[_c('lottie-player',{key:_vm.widget.content,staticClass:"player",attrs:{"src":_vm.widget.content,"autoplay":true,"loop":_vm.widget.loop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }